import React from 'react';

import Button from '../../../../../button/button';

import './fitment-add-vehicle-options-button.scss';

interface FitmentAddVehicleOptionsButtonProps {
  icon: React.ReactNode;
  onClick?: () => void;
  searchBy: string;
}

function FitmentAddVehicleOptionsButton(
  props: FitmentAddVehicleOptionsButtonProps
) {
  const { icon, onClick, searchBy } = props;

  return (
    <Button
      className="fitment-add-vehicle-options-button"
      data-testid="button-container"
      onClick={onClick}
      styleName="container"
    >
      {icon}
      <div styleName="search-by-container">
        <span styleName="search-by-text">Search by </span>
        <span
          data-testid="search-by-option-text"
          styleName="search-by-text search-by-option"
        >
          {searchBy}
        </span>
      </div>
    </Button>
  );
}

export default FitmentAddVehicleOptionsButton;
